import React from 'react';

import { t } from 'state/intl/translations';

import {
  ProductCardOption,
  ProductCardOptionSeparator,
  ProductCardOptionText,
  ProductCardOptionsContainer,
} from './styled';
import { IProductCardOptions } from './types';

export const ProductCardOptions = ({ options, selectedValue, onChange }: IProductCardOptions) => {
  const handlePress = React.useCallback(
    (val: string) => {
      if (onChange) {
        onChange(val);
      }
    },
    [onChange]
  );

  return (
    <ProductCardOptionsContainer>
      {options.map((opt, i) => {
        const selected = opt.value === selectedValue;
        const optionLabel = `${opt.label} ${opt.labelSuffix || ''}`;
        const radioLabel = `${t('option')} ${optionLabel}`;

        return (
          <React.Fragment key={i}>
            <ProductCardOption
              testID="radio-check-list-icon"
              onPress={() => handlePress(opt.value)}
              accessible
              accessibilityLabel={radioLabel}
              accessibilityRole="checkbox"
              aria-checked={selected}
              accessibilityState={{ checked: selected }}
              $isSelected={selected}
            >
              <ProductCardOptionText $isSelected={selected}>{optionLabel}</ProductCardOptionText>
            </ProductCardOption>
            {i < options.length - 1 && <ProductCardOptionSeparator />}
          </React.Fragment>
        );
      })}
    </ProductCardOptionsContainer>
  );
};
